module.exports = {"apiEndpoint":"http://localhost:8080"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = DEN3
// module chunks = 1